import { RouteName } from "@/lib/router/routes";

export default function (playerId: string) {
  return {
    name: RouteName.player,
    params: {
      playerId,
    },
  };
}
